<script>
    import {createEventDispatcher} from 'svelte/internal';
    import {formatDate, pad0} from "../../lib/lib";
    import {clickOutside} from "../../lib/clickOutside.js";
    import AppIcon from "../icons/AppIcon.svelte";

    export let id = '';
    export let name = '';
    export let date = null;
    export let required = false;
    export let hideToday = false;
    export let hideClear = false;
    export let startDate = null;
    export let openRight = false;

    let weekDays = ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'];
    let months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

    let calendar = [];
    let calendarDate = '';
    let calendarMonth = 0;
    let calendarYear = 0;
    let showCalendar = false;
    let ignoreClick = false;


    const dispatch = createEventDispatcher();

    const getDaysInMonth = (month, year) => {
        // Here January is 1 based
        //Day 0 is the last day in the previous month
        return new Date(year, month, 0).getDate();
    };

    const stepMonth = (year, month, step) => {
        let m = month + step;
        let y = year;
        if (m > 12) {
            m = 1;
            y++;
        } else if (m < 1) {
            m = 12;
            y--;
        }

        return [y, m];
    }

    const setCalendar = () => {
        let monthDays = 0;
        let prevMonthDays = 0;
        let dateStr;
        calendar = [];

        monthDays = getDaysInMonth(calendarMonth, calendarYear);
        prevMonthDays = getDaysInMonth(calendarMonth - 1, calendarYear);
        let [previousYear, previousMonth] = stepMonth(calendarYear, calendarMonth, -1);
        let [nextYear, nextMonth] = stepMonth(calendarYear, calendarMonth, 1);

        let d = 0;
        let firstWeekDay = new Date(`${calendarYear}-${pad0(calendarMonth)}-01`).getDay() - 1; // 6 - Saturday
        if (firstWeekDay < 0) {
            firstWeekDay = 6;
        }
        // previous month
        d = prevMonthDays - firstWeekDay + 1;
        for (let index = 0; index < firstWeekDay; index++) {
            dateStr = `${previousYear}-${pad0(previousMonth)}-${pad0(d)}`;
            calendar.push({
                day: d,
                active: false,
                date: dateStr,
                disabled: startDate > dateStr,
            });
            d++;
        }
        // current month
        for (d = 1; d <= monthDays; d++) {
            dateStr = `${calendarYear}-${pad0(calendarMonth)}-${pad0(d)}`;
            calendar.push({
                day: d,
                active: true,
                date: dateStr,
                disabled: startDate > dateStr,
            });
        }
        // next month
        if (calendar.length % 7 > 0) {
            let daysToAdd = 7 - (calendar.length % 7);
            for (let d = 1; d <= daysToAdd; d++) {
                dateStr = `${nextYear}-${pad0(nextMonth)}-${pad0(d)}`;
                calendar.push({
                    day: d,
                    active: false,
                    date: dateStr,
                    disabled: startDate > dateStr,
                });
            }
        }
    }

    const previousMonth = () => {
        ignoreClick = true;
        calendarMonth--;
        if (calendarMonth < 1) {
            calendarYear--;
            calendarMonth = 12;
        }
        setCalendar();
    }

    const nextMonth = () => {
        ignoreClick = true;
        calendarMonth++;
        if (calendarMonth > 12) {
            calendarYear++;
            calendarMonth = 1;
        }
        setCalendar();
    }

    const selectDate = (day) => {
        console.log("selectDate", date);
        if (day.disabled) {
            ignoreClick = true;
            return;
        }

        calendarDate = day.date;
        date = day.date;
        showCalendar = false;
        dispatch('change', date);
    }

    const selectToday = () => {
        let dt = new Date();
        calendarMonth = dt.getMonth() + 1;
        calendarYear = dt.getFullYear();
        calendarDate = `${dt.getFullYear()}-${pad0(dt.getMonth() + 1)}-${pad0(dt.getDate())}`;
        date = calendarDate;
        setCalendar();
        dispatch('change', date);
    }

    const clearDate = () => {
        date = null;
        calendarDate = null;
        dispatch('change', date);
    }

    const initialize = () => {
        let dt;
        if (!date) {
            dt = startDate ? new Date(startDate) : new Date();
        } else {
            dt = new Date(date);
        }

        calendarMonth = dt.getMonth() + 1;
        calendarYear = dt.getFullYear();
        if (date) {
            calendarDate = `${dt.getFullYear()}-${pad0(dt.getMonth() + 1)}-${pad0(dt.getDate())}`;
        }

        setCalendar();
    }

    const onToggleCalendar = () => {
        showCalendar = !showCalendar;
        if (showCalendar) {
            initialize();
        }
    }

    const onCloseCalendar = () => {
        if (!ignoreClick) {
            showCalendar = false;
        }
        ignoreClick = false;
    }


    // initialize();
    //
    // $: if (date != calendarDate) {
    //     initialize();
    // }
</script>

<div class="calendar-control">
    <input type="text" class="form-control date-input" {id} {name} value="{ formatDate(date, 'd-m-y') }"
           autocomplete="off"
           on:click={ onToggleCalendar } {required} readonly="{ date != null }">
    <div class="icon">
        <AppIcon icon="calendar"/>
    </div>
    {#if showCalendar}
        <div class="calendar" class:open-right={ openRight } use:clickOutside on:click_outside="{ onCloseCalendar }">
            <div class="heading">
                <div class="month-nav" on:click="{ previousMonth }">
                    <AppIcon icon="chevron-left" size="18"/>
                </div>
                <div class="title">
                    { months[calendarMonth - 1] } { calendarYear }
                </div>
                <div class="month-nav" on:click="{ nextMonth }">
                    <AppIcon icon="chevron-right" size="18"/>
                </div>
            </div>
            <div class="body">
                {#each weekDays as wDay}
                    <div class="weekday">
                        { wDay }
                    </div>
                {/each}
                {#each calendar as day}
                    <div class="day" class:active={ day.active } class:disabled={ day.disabled }
                         class:selected="{ day.date === calendarDate }"
                         on:click="{ () => selectDate(day) }">
                        { day.day }
                    </div>
                {/each}
            </div>
            {#if !hideToday || !hideClear}
                <div class="footer">
                    {#if !hideToday}
                        <div class="btn btn-link" on:click="{ selectToday }">today</div>
                    {/if}
                    {#if !hideClear}
                        <div class="btn btn-link" on:click="{ clearDate }">clear</div>
                    {/if}
                </div>
            {/if}
        </div>
    {/if}
</div>

<style>
    .calendar-control {
        position: relative;
    }

    .calendar-control .calendar {
        position: absolute;
        z-index: 7000;
    }

    .calendar-control .date-input {
        cursor: pointer;
    }

    .calendar-control .icon {
        position: absolute;
        top: 50%;
        right: 15px;
        transform: translateY(-50%);
    }

    .calendar {
        width: 270px;
        font-size: 0.8rem;
        color: #333;
        background: #fff;
        border: 1px solid #dddddd;
        border-radius: 3px;
        padding: 5px;
    }
    .calendar.open-right {
        right: 0;
    }

    .calendar .heading {
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: #000000;
        margin-bottom: 5px;
    }

    .calendar .heading .month-nav {
        line-height: 1;
        padding: 5px;
        cursor: pointer;
    }

    .calendar .heading .month-nav:hover {
        background: #eeeeee;
    }

    .calendar .heading .title {
        font-weight: 500;
    }

    .calendar .body {
        color: #99b2d8;
    }

    .calendar .body:after {
        content: "";
        clear: both;
        display: table;
    }

    .calendar .footer {
        text-align: center;
    }

    .calendar .weekday {
        display: flex;
        float: left;
        width: 14.285714%;
        font-weight: 500;
        color: #333;
        padding: 5px;
        align-items: center;
        justify-content: center;
    }

    .calendar .day {
        display: flex;
        align-items: center;
        justify-content: center;
        float: left;
        width: 14.285714%;
        color: #c2a599;
        border-radius: 3px;
        padding: 6px 0;
        cursor: pointer;
    }

    .calendar .day:hover {
        background: #eeeeee;
    }

    .calendar .day.active {
        color: #333333;
    }

    .calendar .day.disabled {
        color: #dbdbdb;
    }

    .calendar .day.selected {
        color: #fff;
        background: #357ebd;
    }

    @media (max-width: 576px) {
        .calendar-control .icon {
            right: 10px;
        }
    }

    @media (min-width: 992px) and (max-width: 1199px) {
        .calendar-control .icon {
            right: 10px;
        }
    }
</style>